import React from 'react';
import s from '../Card.scss';

export const EnumLoadingCard = () => {
    return (
        <div className={s.loadingContainer} style={{paddingLeft: 10, paddingRight: 10}}>
            <div className={s.line}><div className={s.feedTitle} /></div>
            <div className={s.line}><div className={s.feedTitle} /></div>
            <div className={s.line}><div className={s.feedTitle} /></div>
            <div className={s.line}><div className={s.feedTitle} /></div>
            <div className={s.line}><div className={s.feedTitle} /></div>
            <div className={s.line}><div className={s.feedTitle} /></div>
        </div>
    );
};



// WEBPACK FOOTER //
// ./src/components/HomeTop/EnumCard/Loading.tsx